import { AppInfo } from '../data/app-info';

export abstract class AppInfoService {
  abstract getAppInfo(): Promise<AppInfo>;
}
